




























import {Component, Vue} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class App extends Vue {
    public drawer: boolean = false;
    public isAllDataLoaded: boolean = false;

    // noinspection JSUnusedGlobalSymbols
    public async mounted(): Promise<void> {
        this.isAllDataLoaded = false;
        if (this.$locator.repository.token !== '') {
            await this.$locator.aclManagement.loadAccounts();
        }
        this.isAllDataLoaded = true;
    }
}
